import { createSelector } from '@reduxjs/toolkit';

export const getIntroTasksState = (state) => state.introTasks;

export const getAllStgetIntroTasksaff = createSelector(
  getIntroTasksState,
  (introTasksState) => introTasksState.data,
);
